<template>
  <BaseButton @click="$emit('click')" :disabled="disabled" :type="type"><slot></slot></BaseButton>
</template>

<script>
import { props } from './BaseButton.js'
import BaseButton from './BaseButton.vue'
export default {
  components: { BaseButton },
  props
}
</script>

<style lang="postcss" scoped>
@import "index.css";
button {
  border-radius: var(--button3BorderRadius);
  height: var(--button3Height);
  font-size: var(--button3TextSize);
}
</style>



// WEBPACK FOOTER //
// src/components/button/BaseButton3.vue